import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {

    constructor() {}

    openWindow(path: string, refName: string, width: number, height: number): any {
        const top = window.top.outerHeight / 2 + window.top.screenY - (height / 2);
        const left = window.top.outerWidth / 2 + window.top.screenX - (width / 2);

        return window.open(
            path,
            refName,
            `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no`);
    }

    openTab(path: string): any {
        window.open(path);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/window.service.ts